import React, { useEffect, useContext } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { HeaderProvider } from "../../contexts/HeaderContext";
import { AuthContext, AuthConsumer } from "../../lib/contexts/AuthContext";
import { AppShell } from "./AppShell";

export default function Layout(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const authContext = useContext(AuthContext);

  useEffect(() => {
    if (authContext && !authContext.isAuthenticated()) {
      navigate("/login");
    }
  }, [authContext, navigate]);

  useEffect(() => {
    const { pathname } = location;
    if (
      pathname === "/commissions-contracts" ||
      pathname.startsWith("/commissions-payout-runs")
    ) {
      requestAnimationFrame(() => {
        document.querySelector(".cp-shell__container")?.scrollTo(0, 0);
        document.querySelector(".cp-shell__main")?.scrollTo(0, 0);
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      });
    }
  }, [location]);

  return (
    <AuthConsumer>
      {(context) => (
        <HeaderProvider>
          <AppShell>{props.children}</AppShell>
        </HeaderProvider>
      )}
    </AuthConsumer>
  );
}

export const LayoutRoute = ({ component: Component, ...rest }) => {
  return (
    <Routes>
      <Route
        {...rest}
        element={
          <Layout>
            <Component />
          </Layout>
        }
      />
    </Routes>
  );
};
